import React from 'react';
import styled from 'styled-components';
import {rgba} from 'polished';

import ContainerHeader from 'components/common/ContainerHeader';

import {colors, containerStyles, scrollStyles} from 'styles/shared';

const QuestionsContainer = styled.div`
  width: 54.4rem;
  height: 83rem;
  padding: 3.9rem 3rem 5rem;
  margin-right: 5rem;
  margin-bottom: 5rem;
  ${containerStyles};
`;

const QuestionHeader = styled(ContainerHeader)`
  margin-bottom: 2rem;
`;

const QuestionList = styled.div`
  height: 71rem;
  overflow-y: auto;
  padding-right: 2rem;
  ${scrollStyles}
`;

const QuestionItem = styled.div`
  padding: 2.5rem 0 3rem;
  border-bottom: ${props => (props.lastItem ? null : `0.2rem solid ${rgba(colors.darkBlue_lighter, 0.3)}`)};
`;

const QuestionTitle = styled.div`
  font-size: 2.1rem;
  line-height: 2.5rem;
  color: ${colors.blue_darker};
  margin-bottom: 1rem;
`;

const QuestionText = styled.div`
  font-size: 1.8rem;
  line-height: 2.2ren;
  color: ${colors.darkBlue_main};
`;

function Questions() {
  const questions = [
    {
      id: 1,
      title: 'How do I use my API Key?',
      text: 'Your API key should be placed in the header field "X-Access-Token" for all requests'
    },
    {
      id: 2,
      title: 'I have an issue with my billing, who do I contact?',
      text: 'Reach out to us using the support form and we will get in touch to assist'
    },
    {
      id: 3,
      title: 'The data for some countries is inaccurate, what can you do about it?',
      text: 'While we take care to ensure data is perfect, there may be times where there are some errors. Please let us know using the support form and we will look in to it'
    },
    {
      id: 4,
      title: 'Where can I find Postman documentation?',
      text: 'You can find the Postman documentation at https://documenter.getpostman.com/view/10808728/SzzgBzyZ?version=latest#9fd92143-20e4-4029-a215-b081d72734a2'
    },
    {
      id: 5,
      title: 'Do you plan to offer other services for hotels, freight, rail and more?',
      text: 'We are currently looking at including more types of data. If you want something specific, please let us know using the support contact form.',
      lastItem: true
    }
  ];

  return (
    <QuestionsContainer>
      <QuestionHeader>Frequently asked questions</QuestionHeader>

      <QuestionList>
        {questions.map(question => {
          return (
            <QuestionItem key={question.id} lastItem={question.lastItem}>
              <QuestionTitle>{question.title}</QuestionTitle>

              <QuestionText>{question.text}</QuestionText>
            </QuestionItem>
          );
        })}
      </QuestionList>
    </QuestionsContainer>
  );
}

export default Questions;
